<template>
  <div class="sidebar__menutoggler pointer" :class="`view-${view}`">
    <div class="select-wrapper select-branch" v-if="view === 'sidebar'">
      <select v-if="superadmin" class="form-control" disabled>
        <option>superadmin</option>
      </select>
      <select v-if="!superadmin"
              class="form-control"
              :disabled="!rights.includes('branches')"
              v-model="tmpBranch">
        <option v-for="branch in branches"
                :value="branch.id"
                :key="`branch-${branch.id}`">
          {{ branch.title }}
        </option>
      </select>
    </div>

    <a @click="$store.commit('toggleCollapsed')" class="svg-a d-inline-block">
      <MenuSvg class="d-md-inline d-none"/>
      <MobileMenuSvg class="d-md-none d-inline"/>
    </a>
  </div>
</template>

<script setup>
import MenuSvg from '@/assets/svg-vue/sidebar/menu.svg'
import MobileMenuSvg from '@/assets/svg-vue/header/menu.svg'
import CalendarSettingsService from "@/services/calendarSettings.helper"
import { computed, onMounted, ref, watch } from "vue"
import { useStore } from "vuex"

defineProps({
  view: {
    type: String
  }
})

const store = useStore()

const tmpBranch = ref('')

const branches = computed(() => store.state.auth.branches)
const branch = computed(() => store.state.auth.branch)
const user = computed(() => store.state.auth.user)
const superadmin = computed(() => store.state.auth.superadmin)
const rights = computed(() => store.state.auth.rights)

// another branch reloads the app, with no doctors selected
watch(tmpBranch, (val, oldval) => {
  store.commit('setBranch', val)
  if(oldval) {
    CalendarSettingsService.setSelectedDoctors([])
    location.reload()
  }
})

// without the branches right the user stays in its own branch
onMounted(() => {
  if(!rights.value.includes('branches') && user.value?.branch_id) {
    tmpBranch.value = user.value.branch_id
    return
  }
  tmpBranch.value = branch.value
})
</script>

<style scoped lang="scss">
@media screen and (max-width: 768px) {
  .sidebar__menutoggler {
    svg {
      position: relative;
    }
  }
}
</style>
